module.exports = __webpack_public_path__ + "static/view-realtime-attendance-057f1dde8e1eea063f8bed20380ad1da.png";